import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  categoryIdChange,
  getProductList,
  getProductSelectedCategoryId,
} from "../../../../react-reduxs/slices/products/product_slice";
import { convertToUnicode } from "../../../../funcs/func";
import { getCompany } from "../../../../react-reduxs/slices/companies/company_slice";
import T4BasketAddBtnComponent from "./components/T4BasketAddBtnComponent";
import T4OrderAddBtnComponent from "./components/T4OrderAddBtnComponent";
import { ApiUrl } from "../../../../consts/api";
import { Button } from "antd";
import { MenuProductAmountType } from "../../../../models/menu_product_amount_type";
import { getTableId } from "../../../../react-reduxs/slices/tables/tableSlice";
import CounterComponent from "../../../../theme/ui-components/counter/CounterComponent";
import { MenuProductModel } from "../../../../services/menu_products/models/menu_product.model";
import ThemeDialog from "@theme/ui-components/dialogs/ThemeDialog";
import T4ProductDetail from "./components/T4ProductDetail";
import ThemeButton from "@theme/ui-components/buttons/ThemeButton";
import ThemeLazyImage from "@theme/ui-components/images/ThemeLayzImage";
import { GetMenuProductListResponseModel } from "../../../../services/menu_products/models/get_menu_product_list.response";

const Template4ProductList = () => {
  const [detailModal, setDetailModal] = useState(false);
  const [selectProduct, setSelectProduct] = useState<
    GetMenuProductListResponseModel | undefined
  >(undefined);
  const dispatch = useDispatch();

  const selectCategoryId = useSelector(getProductSelectedCategoryId);
  const productList = useSelector(getProductList);
  const company = useSelector(getCompany);
  const tableId = useSelector(getTableId);
  const [menuProductAmountListState, setMenuProductAmountListState] = useState<
    MenuProductAmountType[]
  >([]);
  const increment = useCallback((menuProductId: string) => {
    setMenuProductAmountListState((prev) => {
      const updatedList = prev.map((element) =>
        element.menuProductId === menuProductId
          ? { ...element, amount: element.amount + 1 }
          : element,
      );
      if (
        !updatedList.some((element) => element.menuProductId === menuProductId)
      ) {
        updatedList.push({ menuProductId, amount: 2 });
      }
      return updatedList;
    });
  }, []);

  const descrement = useCallback((menuProductId: string) => {
    setMenuProductAmountListState((prev) => {
      const updatedList = prev.map((element) =>
        element.menuProductId === menuProductId && element.amount > 1
          ? { ...element, amount: element.amount - 1 }
          : element,
      );
      if (
        !updatedList.some((element) => element.menuProductId === menuProductId)
      ) {
        updatedList.push({ menuProductId, amount: 2 });
      }
      return updatedList;
    });
  }, []);

  const removeMenuProductAmount = useCallback((menuProductId: string) => {
    setMenuProductAmountListState((prev) =>
      prev.filter((x) => x.menuProductId !== menuProductId),
    );
  }, []);
  const onOpenDetailModal = useCallback(
    (product: GetMenuProductListResponseModel) => {
      setSelectProduct(product);
      setDetailModal(true);
    },
    [],
  );

  return (
    <div style={{ paddingTop: 90, paddingLeft: 10, paddingRight: 10 }}>
      <Button
        className="t4-back-button"
        onClick={() => {
          dispatch(categoryIdChange(""));
        }}
        icon={<i className="fa-duotone fa-solid fa-arrow-left-long fa-lg"></i>}
      />

      {/* Grid yapısını kontrol eden ana sınıf */}
      <div className="t4-product">
        {[...productList]
          .filter((x) => x.menuCategoryId === selectCategoryId)
          .sort((a, b) => a.index - b.index)
          .map((product) => {
            const count =
              menuProductAmountListState.find(
                (x) => x.menuProductId === product.id,
              )?.amount ?? 1;

            return (
              <div className="pcard" key={product.id.toString()}>
                {/* Görsel Alanı */}
                <div
                  className="pcard__img"
                  onClick={() => onOpenDetailModal(product)}
                >
                  <ThemeLazyImage
                    src={
                      product.photo
                        ? `${ApiUrl}/${product.photo}`
                        : "/images/product.png"
                    }
                    alt={product.title}
                  />
                  <div className="pcard__price-badge">
                    {new Intl.NumberFormat("tr-TR", {
                      style: "currency",
                      currency: "TRY", // Eğer dinamikse company?.currency?.code kullanabilirsin
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    }).format(product.price)}
                  </div>
                  <ThemeButton
                    size="small"
                    link
                    className="pcard__detail-btn"
                    icon="pi pi-expand" // Daha modern bir ikon
                    onClick={(e) => {
                      e.stopPropagation(); // Image click eventini tetiklemesin
                      onOpenDetailModal(product);
                    }}
                  />
                </div>

                {/* İçerik Alanı */}
                <div
                  className="pcard__header"
                  onClick={() => onOpenDetailModal(product)}
                >
                  <p className="pcard__title">{product.title}</p>
                </div>

                {/* Sipariş Modu Açıksa Counter ve Butonlar */}
                {company?.orderAtTheTable === true && (
                  <>
                    <div className="pcard__body">
                      <div className="pcard__counter">
                        <CounterComponent
                          color="#549e83"
                          count={count}
                          increment={() => increment(product.id)}
                          descrement={() => descrement(product.id)}
                        />
                      </div>
                    </div>

                    <div className="pcard__footer" style={{ gap: 5 }}>
                      <T4BasketAddBtnComponent
                        menuProduct={product}
                        menuProductAmountList={menuProductAmountListState}
                        removeMenuProductAmount={removeMenuProductAmount}
                        tableId={tableId}
                      />
                      <T4OrderAddBtnComponent
                        menuProduct={product}
                        removeMenuProductAmount={removeMenuProductAmount}
                        menuProductAmountList={menuProductAmountListState}
                        tableId={tableId}
                      />
                    </div>
                  </>
                )}
              </div>
            );
          })}
      </div>
      {detailModal ? (
        <ThemeDialog
          header={selectProduct?.title ?? ""}
          style={{
            width: "90vw",
            borderColor: "#549e83",
            borderWidth: 2,
            borderStyle: "solid",
            zIndex: 100000,
          }}
          visible={detailModal}
          onHide={() => {
            setDetailModal(false);
            setSelectProduct(undefined);
          }}
        >
          <T4ProductDetail
            product={selectProduct!}
            removeMenuProductAmount={removeMenuProductAmount}
            menuProductAmountList={menuProductAmountListState}
            tableId={tableId}
          />
        </ThemeDialog>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Template4ProductList;
